import jwtDecode from 'jwt-decode';
import LocalStorageWrapper from "../lib/localStorageWrapper";
import {
    GET_CURRENT_USER_ROLES_FAILURE,
    GET_CURRENT_USER_ROLES_REQUEST,
    GET_CURRENT_USER_ROLES_SUCCESS
} from "./actionTypes";
import UserProfileClient from "../lib/apiClients/roofSnapApiClient/userProfileClient";
import {CALL_API} from "../middleware/api";

export const getCurrentUserRoles = () => {
    const accessToken = LocalStorageWrapper.getItem('accessToken');

    if (!accessToken) {
        return {
            type: GET_CURRENT_USER_ROLES_FAILURE
        }
    }

    const tokenPayload = jwtDecode(accessToken);
    const userId = parseInt(tokenPayload.name, 10);

    const userProfileClient = new UserProfileClient('v1');
    const request = userProfileClient.getUsersRoles;

    return {
        [CALL_API]: {
            types: [
                GET_CURRENT_USER_ROLES_REQUEST,
                GET_CURRENT_USER_ROLES_SUCCESS,
                GET_CURRENT_USER_ROLES_FAILURE
            ],
            request,
            params: {
                id: userId,
            }
        }
    }
};
